import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

// Components
import App from "./App";
import { NotificationProvider } from "./components/utils/Notification";

// Context
import { AuthProvider } from "./contexts/AuthContext";

// Styles
import "./index.css";
import ErrorBoundary from "./components/main/ErrorBoundary";
import { trackEvent } from "./components/utils/Utils";

// Catch global JavaScript errors
window.onerror = (message, source, lineno, colno, error) => {
  trackEvent("fatal_error", {
    message: message ? message.toString() : "Unknown error",
    source,
    lineno,
    colno,
    error: error ? error.message : "Unknown error",
  });
};

// Catch unhandled Promise rejections
window.onunhandledrejection = (event) => {
  trackEvent("fatal_error_3", {
    message: event.reason
      ? event.reason.message
      : "Unhandled promise rejection",
  });
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <NotificationProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </NotificationProvider>
        </AuthProvider>
      </I18nextProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
